// Vendor libraries
import { EventEmitter } from '@angular/core';
// Directives
import { MetricSelectorModalDirective } from '../metric-selector-modal/metric-selector-modal.directive';
import { SingleMetricByCategoryListComponent } from 'CalculationsApp/ts/features/metric-selector-modal/components/single-metric-by-category-list/single-metric-by-category-list.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i2 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i5 from "../single-metric-by-category-list/single-metric-by-category-list.component";
/**
 * Single Select Metric Modal
 *
 * A modal that allows users to select at most one metric.
 * This modal is opened by metric-autocomplete-in-place 'handleButtonClick'
 *
 * Inputs:
 *    selectedMetricName: The internal name of the metric to be preselected on modal open
 *
 * Outputs:
 *    selectMetricHandler: An event emitter that emits the selected metric.
 */
export class SingleMetricSelectorModalComponent extends MetricSelectorModalDirective {
    constructor() {
        super(...arguments);
        this.submitModalHandler = new EventEmitter();
        this.submitModalAutocompleteHandler = new EventEmitter();
    }
    submitModal(metric) {
        const validMetrics = this.validateFeatureNeeded([metric]);
        if (validMetrics.length > 0) {
            this.submitModalHandler.emit(metric);
        }
        // Because only one metric is selected, automatically close the modal
        this.closeModal();
    }
    submitModalAutocomplete(autocompleteResult) {
        const validResults = this.validateFeatureNeeded([autocompleteResult]);
        if (validResults.length > 0) {
            this.submitModalAutocompleteHandler.emit(autocompleteResult);
        }
        // Because only one metric is selected, automatically close the modal
        this.closeModal();
    }
    resetModal() {
        this.singleMetricByCategoryList.reset();
    }
}
SingleMetricSelectorModalComponent.ɵfac = /*@__PURE__*/ (() => { let ɵSingleMetricSelectorModalComponent_BaseFactory; return function SingleMetricSelectorModalComponent_Factory(t) { return (ɵSingleMetricSelectorModalComponent_BaseFactory || (ɵSingleMetricSelectorModalComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SingleMetricSelectorModalComponent)))(t || SingleMetricSelectorModalComponent); }; })();
SingleMetricSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleMetricSelectorModalComponent, selectors: [["ycn-single-metric-selector-modal"]], viewQuery: function SingleMetricSelectorModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(SingleMetricByCategoryListComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.singleMetricByCategoryList = _t.first);
    } }, inputs: { selectedMetricName: "selectedMetricName" }, outputs: { submitModalHandler: "submitModalHandler", submitModalAutocompleteHandler: "submitModalAutocompleteHandler" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 5, consts: [[3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "form-row"], [3, "submitHandler", "searchType"], [3, "submitMetricHandler", "selectedMetricName", "categories"], [1, "modal-footer"]], template: function SingleMetricSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function SingleMetricSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function SingleMetricSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "ycn-icon-search-autocomplete", 4);
        i0.ɵɵlistener("submitHandler", function SingleMetricSelectorModalComponent_Template_ycn_icon_search_autocomplete_submitHandler_4_listener($event) { return ctx.submitModalAutocomplete($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "ycn-single-metric-by-category-list", 5);
        i0.ɵɵlistener("submitMetricHandler", function SingleMetricSelectorModalComponent_Template_ycn_single_metric_by_category_list_submitMetricHandler_5_listener($event) { return ctx.submitModal($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(6, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.open);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Financial Metric");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("searchType", ctx.searchType);
        i0.ɵɵadvance();
        i0.ɵɵproperty("selectedMetricName", ctx.selectedMetricName)("categories", ctx.categories);
    } }, dependencies: [i1.FeatureNeededComponent, i2.IconSearchAutocompleteComponent, i3.ModalBaseComponent, i4.SimpleModalHeaderComponent, i5.SingleMetricByCategoryListComponent], encapsulation: 2 });
